import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { observable } from 'mobx'
import { Workspace } from '@/features/iam/workspaces/Workspace'
import { JobLegend } from '@/features/jobs/job-legend'
import type { JobIntakeResponse } from '@/features/jobs/job-intake-response'
import { unixEpoch } from '@/utils/date-util'

export type DraftJobProps = ModelProps<DraftJob>

/**
 * Draft version of a job.
 */
export class DraftJob extends Model<DraftJob> {
  id = Id.none

  @observable accessor title = ''
  @observable accessor legendId = Id.none
  @observable accessor legendName = ''
  @observable accessor workspace = Workspace.none
  @observable accessor isSubmitted = false
  @observable accessor createdAt = unixEpoch()
  @observable.struct accessor answers: JobIntakeResponse[] = []
  @observable accessor couponId: string | null = null
  @observable accessor legend = JobLegend.none
  @observable accessor requestedProviderUserId: Id | null = null
  @observable accessor paidAmount = 0
}
